import { router } from "@inertiajs/react"
import { useCallback, useState } from "react"

import { documentsPath } from "@/routes"

type OperationType =
  | "merge_pdfs"
  | "split_pdf"
  | "reorder_pages"
  | "protect_pdf"
  | "sign_pdf"
  | "image_to_pdf"

interface UploadResult {
  id: number
  expires_at: string | null
}

export function useDocumentUpload() {
  const [uploading, setUploading] = useState(false)

  const uploadDocument = useCallback(
    async (
      blob: Blob,
      filename: string,
      operationType: OperationType,
    ): Promise<UploadResult | null> => {
      setUploading(true)

      try {
        const formData = new FormData()
        formData.append("file", blob, filename)
        formData.append("filename", filename)
        formData.append("operation_type", operationType)

        const csrfToken = document
          .querySelector('meta[name="csrf-token"]')
          ?.getAttribute("content")

        const response = await fetch(documentsPath(), {
          method: "POST",
          headers: {
            "X-CSRF-Token": csrfToken ?? "",
          },
          body: formData,
        })

        if (!response.ok) {
          return null
        }

        const result = (await response.json()) as UploadResult
        router.flushAll()
        return result
      } catch {
        return null
      } finally {
        setUploading(false)
      }
    },
    [],
  )

  return { uploadDocument, uploading }
}
